import { Menu } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import { useState, useEffect } from 'react'
import { NavSlice, HeaderSlice, LocationSlice } from 'redux/reducers'
import { useNavigate } from 'react-router-dom'
import { Card } from 'layouts'
import './Nav.scss'
import classnames from 'classnames'
import { getNavDataList } from './NavData.js'
import { CSSTransition } from 'react-transition-group'
import { getNavWidth, getStroage, waitTime } from 'utils'

let timeBar = null
// let isProduction = false

export const Nav = ({ outlineBorder, hoverBorder }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const openKeys = useSelector(state => state.NavSlice.openKeys)
    const flag = useSelector(state => state.HeaderSlice.flag)
    const selectedKeys = useSelector(state => state.NavSlice.selectedKeys)
    const [hide, setHide] = useState(true)
    const userInfo = useSelector(state => state.HeaderSlice.userInfo)
    // const monitorAuth = userInfo?.monitor
    const permissions = userInfo?.permissions
    const roles = userInfo?.roles
    const [navAuthList, setNavAuthList] = useState()
    const [navBriefList, setNavBriefList] = useState()
    const entryMenuList = useSelector(state => state.AppSlice.authLocationData)?.data
    const language = getStroage('language')
    const [readerToggle, setReaderToggle] = useState(false)
    const projectBaseData = useSelector(state => state.HeaderSlice.projectBaseData)
    const receiverTypeList = projectBaseData?.data?.receiverType
    const navList = getNavDataList(receiverTypeList)
    const theme = getStroage('theme')

    // 递归过滤数据中children为空数组的节点
    const filterEmptyChildren = (data) => {
        if (!Array.isArray(data)) {
            return []
        }

        return data
            .map(item => {
                // 深度拷贝当前项，避免修改原数据
                const newItem = { ...item }

                // 如果当前项有children属性且是数组
                if (newItem.children && Array.isArray(newItem.children)) {
                    if (newItem.children.length === 0) {
                        // children为空数组，返回null标记为需要过滤
                        return null
                    } else {
                        // children不为空，递归过滤子节点
                        newItem.children = filterEmptyChildren(newItem.children)

                        // 如果过滤后children为空，也返回null
                        if (newItem.children.length === 0) {
                            return null
                        }
                    }
                }

                return newItem
            })
            .filter(item => item !== null) // 过滤掉标记为null的项
    }

    // 权限
    useEffect(() => {
        if (userInfo && entryMenuList) {
            // 其它权限
            const handleFun = dataList => {
                let newArray = []

                dataList.forEach(item => {
                    if (item.key === 'production') return newArray
                    const isPermission = permissions.find(p => p.indexOf(item.permission) === 0)
                    if (item.children) {
                        const newObj = { ...item }
                        newObj.children = handleFun(item.children)
                        newArray.push(newObj)
                    } else {
                        // const isProjectAdmin = roles.find(p => p === 'projectAdmin')
                        const isAdmin = roles.find(p => p === 'admin')
                        if (isAdmin) {
                            newArray.push(item)
                        } else {
                            if (isPermission) {
                                newArray.push(item)
                            }
                        }
                    }
                })
                return newArray
            }

            // 录入项权限
            const handleEntryListFun = dataList => {
                let newArray = []
                dataList.forEach(item => {
                    if (item.children) {
                        const newObj = { ...item }
                        newObj.children = handleEntryListFun(item.children)
                        newArray.push(newObj)
                    } else {
                        const isPermission = entryMenuList.find(p => item.permission === p)
                        if (isPermission) {
                            newArray.push(item)
                        }
                    }
                })
                return newArray
            }
            const entryList = navList.filter(item => item.key === 'production')
            // 合并
            let otherList = handleFun(navList)
            let MointerList = handleEntryListFun(entryList)
            otherList.splice(1, 0, ...MointerList)
            setNavAuthList(filterEmptyChildren(otherList))
        }
    }, [userInfo, entryMenuList])

    // 取消 input title 提示信息
    useEffect(() => {
        const srceenWidth = window.screen.width
        if (srceenWidth < 960) {
            dispatch(HeaderSlice.actions.changepOutlineBorder(true))
        }
        document.querySelectorAll('.ant-menu-item-group-title').forEach(div => div.setAttribute('title', ''))
    }, [])

    const handleScroll = () => {
        clearTimeout(timeBar)
        setHide(false)
        timeBar = setTimeout(() => {
            setHide(true)
        }, 1000)
    }

    const onClick = data => {
        dispatch(HeaderSlice.actions.changeMenuStyle(!flag)) // 浏览器菜单上滑效果
        const widthBrowser = document.body.clientWidth
        if (widthBrowser < 960) dispatch(HeaderSlice.actions.changepOutlineBorder(!outlineBorder)) // 浏览器宽度小于960浏览器菜单缩放
        dispatch(NavSlice.actions.addSelectedKeys([data.key])) // 记住 menu 选中状态
        let authLocationList // 有权限的船列表
        const handleFun = (navAuthList, key) => {
            navAuthList.forEach(item => {
                if (item.key === key && item.menucode)
                    // authLocationList = monitorAuth?.find(p => item.menucode === p.menuCode)?.locationBtns
                    authLocationList = []
                if (item.children) handleFun(item.children, key)
            })
        }
        handleFun(navAuthList, data.key)
        if (data.key === '/project_summary') {
            dispatch(LocationSlice.actions.clearLocationType()) // 清空locationData
        } 
        navigate(data.key, { state: { authLocationList } }) // 前端路由导航 - 跳转
    }
    const onOpenChange = openKeys => dispatch(NavSlice.actions.addOpenKeys(openKeys)) // 记住 menu 展开状态

    // 收缩边栏
    useEffect(() => {
        if (outlineBorder && navAuthList) {
            const result = []
            const handleFun = arr => {
                arr.forEach(item => {
                    if (item.icon) {
                        result.push({ icon: item.icon, key: item.key })
                        if (item.children) {
                            handleFun(item.children)
                        }
                    } else if (item.type === 'group') {
                        result.push({ key: item.key, label: '--' })
                        if (item.children) {
                            handleFun(item.children)
                        }
                    }
                })
            }
            handleFun(navAuthList)
            setNavBriefList(result)
        }
    }, [outlineBorder, navAuthList])

    useEffect(async () => {
        if (!readerToggle) {
            await waitTime(100)
            dispatch(HeaderSlice.actions.changepHoverBorder(false))
        }
    }, [readerToggle])

    if (!navAuthList) <></>
    return (
        <Card
            className={
                theme === 'blue'
                    ? classnames('nav-card', {
                          hideScroll: hide,
                          outlineBorder: outlineBorder,
                          'outlineBorder-active': hoverBorder,
                      })
                    : classnames('dark-nav-card', {
                          hideScroll: hide,
                          outlineBorder: outlineBorder,
                          'outlineBorder-active': hoverBorder,
                      })
            }
            onScroll={handleScroll}
            onMouseWheel={e => {
                let ea = e || window.event
                ea.stopPropagation()
                ea.cancelBubble = true
            }}
            onDOMMouseScroll={e => {
                let ea = e || window.event
                ea.stopPropagation()
                ea.cancelBubble = true
            }}
        >
            {outlineBorder ? (
                hoverBorder ? (
                    <CSSTransition
                        in={readerToggle}
                        appear={true}
                        timeout={{
                            appear: 0,
                            enter: 0,
                            exit: 0,
                        }}
                        classNames={{
                            appear: 'my-appear',
                            appearActive: 'my-active-appear',
                            appearDone: 'my-done-appear',

                            enter: 'my-enter',
                            enterActive: 'my-active-enter',
                            enterDone: 'my-done-enter',

                            exit: 'my-exit',
                            exitActive: 'my-active-exit',
                            exitDone: 'my-done-exit',
                        }}
                    >
                        <Menu
                            className='outlineBorder-nav-active nav'
                            mode='inline'
                            defaultOpenKeys={[
                                '/dashboard',
                                '/setting/configuration',
                                '/setting/resources',
                                '/setting/plan',
                            ]}
                            {...(openKeys?.length > 0 ? { openKeys: openKeys } : {})}
                            selectedKeys={selectedKeys}
                            onClick={onClick}
                            onOpenChange={onOpenChange}
                            items={navAuthList}
                            onMouseLeave={e => {
                                setReaderToggle(false)
                            }}
                            style={{
                                width: getNavWidth(language) + 'px',
                            }}
                        />
                    </CSSTransition>
                ) : (
                    <Menu
                        className='outlineBorder-nav nav'
                        mode='inline'
                        items={navBriefList}
                        onMouseEnter={e => {
                            setReaderToggle(true)
                            dispatch(HeaderSlice.actions.changepHoverBorder(true))
                        }}
                    />
                )
            ) : (
                <Menu
                    className='nav'
                    mode='inline'
                    defaultOpenKeys={['/dashboard', '/setting/configuration', '/setting/resources', '/setting/plan']}
                    {...(openKeys?.length > 0 ? { openKeys: openKeys } : {})}
                    selectedKeys={selectedKeys}
                    onClick={onClick}
                    onOpenChange={onOpenChange}
                    items={navAuthList}
                    style={{
                        width: getNavWidth(language) + 'px',
                    }}
                />
            )}
        </Card>
    )
}
